'use strict'

import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import App from './components/App'
import LocalStorage from './localStorage'
import configureStore from './store'
import registerServiceWorker from './worker'
import './assets/styles/tailwind.css'
import './assets/styles/index.scss'

const store = configureStore()
LocalStorage.configure({ keyPrefix: 'meetingcosts' })

if (process.env.NODE_ENV !== 'production') {
  var axe = require('react-axe')
  axe(React, ReactDOM, 1000)
}

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={<span />}>
      <App />
    </Suspense>
  </Provider>,
  document.getElementById('app')
)

registerServiceWorker()
